import AscMilestoneProgressBar from "./AscMilestoneProgressBar/AscMilestoneProgressBar";
import { AscProgressBarProps } from "./AscProgressBar.types";
import AscSimpleProgressBar from "./AscSimpleProgressBar/AscSimpleProgressBar";
import AscSkillsProgressBar from "./AscSkillsProgressBar/AscSkillsProgressBar";
import AscStepsProgressBar from "./AscStepsProgressBar/AscStepsProgressBar";

export default function AscProgressBar({
  type = "simple",
  max = 100,
  ...rest
}: AscProgressBarProps) {
  switch (type) {
    case "simple":
      return <AscSimpleProgressBar max={max} {...rest} />;
    case "steps":
      return <AscStepsProgressBar max={max} {...rest} />;
    case "skills":
      return <AscSkillsProgressBar max={max} {...rest} />;
    case "milestone":
      return <AscMilestoneProgressBar max={max} {...rest} />;
    case "dotted-milestone":
      return <AscMilestoneProgressBar dotted max={max} {...rest} />;
    case "vertical-milestone":
      return <AscMilestoneProgressBar max={max} dotted vertical {...rest} />;
  }
}
